var _rect, _mask, _path, _mask2, _path2, _path3, _line, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFyndricon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 50.5,
    rx: 4,
    stroke: "url(#paint0_linear_6663_26966)",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_6663_26966",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 31.5C39 33.433 37.433 35 35.5 35C33.567 35 32 33.433 32 31.5C32 29.567 33.567 28 35.5 28C37.433 28 39 29.567 39 31.5ZM33.4293 31.5C33.4293 32.6436 34.3564 33.5707 35.5 33.5707C36.6436 33.5707 37.5707 32.6436 37.5707 31.5C37.5707 30.3564 36.6436 29.4293 35.5 29.4293C34.3564 29.4293 33.4293 30.3564 33.4293 31.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 31.5C39 33.433 37.433 35 35.5 35C33.567 35 32 33.433 32 31.5C32 29.567 33.567 28 35.5 28C37.433 28 39 29.567 39 31.5ZM33.4293 31.5C33.4293 32.6436 34.3564 33.5707 35.5 33.5707C36.6436 33.5707 37.5707 32.6436 37.5707 31.5C37.5707 30.3564 36.6436 29.4293 35.5 29.4293C34.3564 29.4293 33.4293 30.3564 33.4293 31.5Z",
    stroke: "url(#paint1_linear_6663_26966)",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_6663_26966)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_6663_26966",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5C28 33.433 26.433 35 24.5 35C22.567 35 21 33.433 21 31.5C21 29.567 22.567 28 24.5 28C26.433 28 28 29.567 28 31.5ZM22.4293 31.5C22.4293 32.6436 23.3564 33.5707 24.5 33.5707C25.6436 33.5707 26.5707 32.6436 26.5707 31.5C26.5707 30.3564 25.6436 29.4293 24.5 29.4293C23.3564 29.4293 22.4293 30.3564 22.4293 31.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5C28 33.433 26.433 35 24.5 35C22.567 35 21 33.433 21 31.5C21 29.567 22.567 28 24.5 28C26.433 28 28 29.567 28 31.5ZM22.4293 31.5C22.4293 32.6436 23.3564 33.5707 24.5 33.5707C25.6436 33.5707 26.5707 32.6436 26.5707 31.5C26.5707 30.3564 25.6436 29.4293 24.5 29.4293C23.3564 29.4293 22.4293 30.3564 22.4293 31.5Z",
    stroke: "url(#paint2_linear_6663_26966)",
    strokeWidth: 4,
    mask: "url(#path-3-inside-2_6663_26966)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H19.254C19.7682 10 20.1985 10.39 20.2491 10.9017L20.5333 13.7778M20.5333 13.7778L21.7509 26.0983C21.8015 26.61 22.2319 27 22.746 27H37.8623C38.3198 27 38.7189 26.6896 38.8315 26.2463L41.6833 15.0241C41.8439 14.392 41.3663 13.7778 40.7141 13.7778H20.5333Z",
    stroke: "url(#paint3_linear_6663_26966)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 58.125,
    y1: 42.25,
    x2: 1.875,
    y2: 42.25,
    stroke: "url(#paint4_linear_6663_26966)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 52.5L37.5 60",
    stroke: "url(#paint5_linear_6663_26966)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 52.5L23.4375 60",
    stroke: "url(#paint6_linear_6663_26966)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 60H20.625",
    stroke: "url(#paint7_linear_6663_26966)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6663_26966",
    x1: 2.26491,
    y1: -1.41346,
    x2: 49.7414,
    y2: 60.3517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6663_26966",
    x1: 32.2642,
    y1: 27.8115,
    x2: 38.7602,
    y2: 35.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6663_26966",
    x1: 21.2642,
    y1: 27.8115,
    x2: 27.7602,
    y2: 35.2062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6663_26966",
    x1: 15.057,
    y1: 9.54231,
    x2: 28.2685,
    y2: 34.3129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6663_26966",
    x1: 62.5,
    y1: 44.5,
    x2: 1.87499,
    y2: 40.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6663_26966",
    x1: 35.6958,
    y1: 52.2981,
    x2: 39.3912,
    y2: 53.3497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6663_26966",
    x1: 23.5083,
    y1: 52.2981,
    x2: 27.2037,
    y2: 53.3497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6663_26966",
    x1: 39.5693,
    y1: 60.0269,
    x2: 39.486,
    y2: 58.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyndricon1);
export default __webpack_public_path__ + "static/media/fyndricon1.38843d0cfc45cab020ac0ada49a32435.svg";
export { ForwardRef as ReactComponent };